var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pageTitleContainer",style:(_vm.containerStyle)},[_c('md-field',{staticClass:"pageTitle",attrs:{"md-inline":""}},[_c('label',[_vm._v("Title")]),_c('md-input',{attrs:{"disabled":_vm.editingMode != 'editing'},model:{value:(_vm.title),callback:function ($$v) {_vm.title=$$v},expression:"title"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }